<!-- 联系我们 -->
<template>
  <div class='template-container'>
    <div class="template-content">
      <div class="section section1-main">
        <h1 class="section1-title">告诉我们您的需求</h1>
        <div class="section1-desc">您可通过以下联系方式告诉我们您的需求，我们的销售经理/技术顾问将会针对您的需求为您提供最适合您的专业帮助。</div>
        <div class="section1-content">
          <div class="content-item">
            <!-- <div class="item-main">
              <h2 class="item-title">营销中心</h2>
              <p class="item-desc">工业级无人机产品销售、解决方案、区域合作代理咨询等</p>
              <div class="item-contact">
                <div class="contact-main">
                  <img class="contact-img"
                       src="/static/images/about/contact/tel.png"
                       alt="telphone"><span class="contact-text">13699268856</span>
                </div>
                <div class="contact-main">
                  <img class="contact-img"
                       src="/static/images/about/contact/mail.png"
                       alt="email"><span class="contact-text">sales@aeronitor.com</span>
                </div>
              </div>
            </div> -->
            <div class="item-main">
              <h2 class="item-title">创新业务</h2>
              <p class="item-desc">能源、军用、科研等工业无人机前沿应用探索和运营托管服务等</p>
              <div class="item-contact">
                <div class="contact-main">
                  <img class="contact-img" src="/static/images/about/contact/tel.png" alt="telphone"><span
                    class="contact-text">13488811399</span>
                </div>
                <div class="contact-main">
                  <img class="contact-img" src="/static/images/about/contact/mail.png" alt="email"><span
                    class="contact-text">1454828@qq.com</span>
                </div>
              </div>
            </div>
            <!-- <div class="item-main">
              <h2 class="item-title">市场合作</h2>
              <p class="item-desc">媒体合作、会展服务、活动推广等品宣事务合作咨询</p>
              <div class="item-contact">
                <div class="contact-main">
                  <img class="contact-img"
                       src="/static/images/about/contact/tel.png"
                       alt="telphone"><span class="contact-text">13240113344</span>
                </div>
                <div class="contact-main">
                  <img class="contact-img"
                       src="/static/images/about/contact/mail.png"
                       alt="email"><span class="contact-text">kongxiangyu@aeronitor.com</span>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="section section3-main">
        <h2 class="section3-title">公司地址</h2>
        <div class="section3-content">
          <div class="content-middle">
            <div class="middle-left">
              <img src="/static/images/about/contact/map.jpg" alt="公司地址 map">
            </div>
            <div class="middle-right">
              <h2 class="right-title">航翊科技</h2>
              <div class="right-desc">北京市海淀区西北旺东路10号院东区5号楼400室</div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 100px;"></div>
      <!-- <div class="section section2-main">
        <h2 class="section2-title">联系区域经理</h2>
        <div class="section2-content">
          <div class="list-main"
               v-for="(item, index) in infoData"
               :key="index">
            <div class="main-item">
              <h2 class="item-title">{{item.title}}</h2>
              <div class="item-content">
                <div class="content-item"
                     v-for="(element, index) in item.list"
                     :key="index">
                  <h3 class="item-subtitle">{{element.title}}</h3>
                  <div class="item-subcontent"
                       v-for="(val, index) in element.list"
                       :key="index">
                    <span class="content-name">{{val.name}}</span>
                    <span class="content-tel">{{val.tel}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      infoData: [
        {
          title: "东北区域",
          list: [
            {
              title: "黑龙江、辽宁、吉林",
              list: [
                {
                  name: "崔经理",
                  tel: "13091439568"
                }
              ]
            }
          ]
        },
        {
          title: "华北区域",
          list: [
            {
              title: "河南省",
              list: [
                {
                  name: "牛经理",
                  tel: "13837102826"
                }
              ]
            },
            {
              title: "河北省",
              list: [
                {
                  name: "郭经理",
                  tel: "18600286552"
                }
              ]
            },
            {
              title: "山东省",
              list: [
                {
                  name: "张经理",
                  tel: "15653921290"
                }
              ]
            },
            {
              title: "山西省",
              list: [
                {
                  name: "郭经理",
                  tel: "18600286552"
                }
              ]
            }
          ]
        },
        {
          title: "华中区域",
          list: [
            {
              title: "湖北省",
              list: [
                {
                  name: "张经理",
                  tel: "15827461958"
                }
              ]
            }
          ]
        },
        {
          title: "华东区域",
          list: [
            {
              title: "江苏省",
              list: [
                {
                  name: "黎经理",
                  tel: "17712892198"
                }
              ]
            },
            {
              title: "安徽省",
              list: [
                {
                  name: "黎经理",
                  tel: "17712892198"
                }
              ]
            }
          ]
        },
        {
          title: "西北区域",
          list: [
            {
              title: "陕西省、甘肃、宁夏",
              list: [
                {
                  name: "李经理",
                  tel: "18161864182"
                }
              ]
            },
            {
              title: "青海省",
              list: [
                {
                  name: "李经理",
                  tel: "18161864182"
                }
              ]
            },
            {
              title: "新疆维吾尔自治区",
              list: [
                {
                  name: "周经理",
                  tel: "13565834850"
                }
              ]
            }
          ]
        },
        {
          title: "西南区域",
          list: [
            {
              title: "四川、重庆、西藏",
              list: [
                {
                  name: "杨经理",
                  tel: "18684026156"
                }
              ]
            },
            {
              title: "云南省",
              list: [
                {
                  name: "程经理",
                  tel: "15281054811"
                }
              ]
            },
            {
              title: "贵州省",
              list: [
                {
                  name: "杨经理",
                  tel: "18684026156"
                }
              ]
            }
          ]
        },
        {
          title: "华南区域",
          list: [
            {
              title: "广东省",
              list: [
                {
                  name: "翟经理",
                  tel: "13641303113"
                }
              ]
            },
            {
              title: "广西省",
              list: [
                {
                  name: "程经理",
                  tel: "15281054811"
                }
              ]
            }
          ]
        },
        // {
        //   title: "编队事业部",
        //   list: [
        //     {
        //       title: "",
        //       list: [
        //         {
        //           name: "魏经理",
        //           tel: "13264128129"
        //         }
        //       ]
        //     }
        //   ]
        // },
        {
          title: "其他",
          list: [
            {
              title: "其他未列明省份",
              list: [
                {
                  name: "营销中心座机",
                  tel: "010-58650999"
                }
              ]
            },
            {
              title: "石油行业",
              list: [
                {
                  name: "翟经理",
                  tel: "13641303113"
                }
              ]
            },
            {
              title: "电力行业",
              list: [
                {
                  name: "王经理",
                  tel: "18600918660"
                },
                {
                  name: "孔经理",
                  tel: "13240113344"
                }
              ]
            }
          ]
        }
      ]
    };
  }
};
</script>

<style lang='stylus' scoped>
.template-container {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  background: #fff;

  .template-content {
    width: 80%;
    max-width: 1280px;
    margin: 0 auto;

    .section {
      padding-top: 100px;
    }

    .section1-main {
      .section1-title {
        font-size: 66px;
        font-weight: 600;
        color: #111111;
        line-height: 92px;
        text-align: center;
      }

      .section1-desc {
        max-width: 1000px;
        margin: 0 auto;
        font-size: 21px;
        font-weight: 400;
        color: #444444;
        line-height: 38px;
        padding: 80px 0;
        text-align: center;
      }

      .section1-content {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .content-item {
          width: 50%;
          text-align: center;
          display: flex;
          justify-content: center;

          .item-main {
            flex: 1;
            margin-right: 20px;
            margin-bottom: 20px;
            box-sizing: border-box;
            border: 1px solid #EBEBEB;

            .item-title {
              padding: 60px 0;
              font-size: 36px;
              color: #111111;
              line-height: 50px;
            }

            .item-desc {
              min-height: 150px;
              padding: 0 10px;
              padding-bottom: 20px;
              font-size: 22px;
              color: #111111;
              line-height: 30px;
            }

            .item-contact {
              .contact-main {
                display: flex;
                padding: 10px 0;
              }

              .contact-img {
                width: 30px;
                height: 30px;
                margin-left: 20px;
                margin-right: 10px;
              }

              .contact-text {
                line-height: 30px;
                font-size: 16px;
              }
            }
          }
        }
      }
    }

    .section3-main {
      .section3-title {
        font-size: 48px;
        color: #111111;
        line-height: 75px;
        padding-bottom: 40px;
        text-align: center;
      }

      .section3-content {
        .content-middle {
          padding-top: 50px;
          display: flex;

          .middle-left {
            width: 540px;

            img {
              width: 100%;
            }
          }

          .middle-right {
            flex: 1;
            padding: 40px;

            .right-title {
              font-size: 24px;
              color: #111111;
              line-height: 22px;
              padding-bottom: 20px;
            }

            .right-desc {
              font-size: 20px;
              color: #444444;
              line-height: 42px;
            }
          }
        }
      }
    }

    .section2-main {
      .section2-title {
        font-size: 54px;
        color: #111111;
        line-height: 75px;
        padding-bottom: 180px;
      }

      .section2-content {
        .list-main {
          .main-item {
            display: flex;

            .item-title {
              width: 120px;
              height: 100%;
              font-size: 24px;
              color: #999999;
              line-height: 50px;
              padding: 20px;
            }

            .item-content {
              flex: 1;

              .content-item {
                display: inline-block;
                width: 360px;
                border: 1px solid #EBEBEB;
                margin-left: 20px;
                margin-bottom: 20px;
                padding: 20px;
                box-sizing: border-box;
                vertical-align: top;

                .item-subtitle {
                  font-size: 36px;
                  color: #111111;
                  line-height: 50px;
                  padding-bottom: 60px;
                  white-space: nowrap;
                }

                .item-subcontent {
                  display: inline-block;
                  width: 50%;
                  font-size: 22px;
                  color: #444444;
                  line-height: 30px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media all and (min-width: 769px) and (max-width: 1400px) {
  .template-container {
    .template-content {
      .section {
        padding-top: 100px;
      }

      .section1-main {
        .section1-title {
          font-size: 36px;
          line-height: 46px;
        }

        .section1-desc {
          min-width: 700px;
          font-size: 18px;
          line-height: 32px;
        }

        .section1-content {
          .content-item {
            width: 800px;
            text-align: center;
            display: flex;
            justify-content: center;

            .item-main {
              .item-title {
                font-size: 32px;
              }

              .item-desc {
                min-height: 120px;
                font-size: 16px;
              }
            }
          }
        }
      }

      .section3-main {
        .section3-title {
          font-size: 32px;
        }

        .section3-content {
          .content-middle {
            .middle-left {
              width: 480px;

              img {
                width: 100%;
              }
            }

            .middle-right {
              flex: 1;
              padding: 20px;

              .right-title {
                font-size: 20px;
                line-height: 30px;
                padding-bottom: 20px;
              }

              .right-desc {
                font-size: 16px;
                color: #444444;
                line-height: 32px;
              }
            }
          }
        }
      }

      .section2-main {
        .section2-title {
          font-size: 32px;
          padding-bottom: 100px;
        }

        .section2-content {
          .list-main {
            .main-item {
              display: flex;

              .item-title {
                font-size: 24px;
              }

              .item-content {
                flex: 1;

                .content-item {
                  width: 320px;

                  .item-subtitle {
                    font-size: 32px;
                  }

                  .item-subcontent {
                    font-size: 20px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media all and (min-width: 769px) and (max-width: 1400px) {
  .section3-main {
    .section3-content {
      .content-middle {
        .middle-left {
          width: 400px !important;
        }
      }
    }
  }
}

// 移动端
@media all and (min-width: 415px) and (max-width: 768px) {
  .template-container {
    .template-content {
      width: 100%;

      .section {
        padding-top: 80px;
      }

      .section1-main {
        .section1-title {
          font-size: 36px;
          line-height: 46px;
        }

        .section1-desc {
          max-width: 600px;
          font-size: 16px;
          line-height: 26px;
          padding: 40px 20px;
          box-sizing: border-box;
        }

        .section1-content {
          .content-item {
            width: calc(100% - 40px);
            text-align: center;
            display: flex;
            justify-content: center;

            .item-main {
              &:nth-child(2), &:nth-child(4) {
                margin-right: 0;
              }

              .item-title {
                font-size: 32px;
              }

              .item-desc {
                font-size: 16px;
              }

              .item-contact {
                .contact-img {
                  width: 30px;
                  height: 30px;
                }

                .contact-text {
                  line-height: 30px;
                }
              }
            }
          }
        }
      }

      .section2-main {
        .section2-title {
          font-size: 32px;
          line-height: 42px;
          padding-bottom: 80px;
          padding-left: 20px;
        }

        .section2-content {
          .list-main {
            .main-item {
              display: block;

              .item-title {
                width: 100%;
                font-size: 24px;
              }

              .item-content {
                .content-item {
                  width: calc(50% - 40px);

                  .item-subtitle {
                    font-size: 26px;
                  }

                  .item-subcontent {
                    font-size: 16px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media all and (min-width: 320px) and (max-width: 414px) {
  .template-container {
    .template-content {
      width: 100%;

      .section {
        padding-top: 80px;
      }

      .section1-main {
        .section1-title {
          font-size: 36px;
          line-height: 46px;
        }

        .section1-desc {
          max-width: 600px;
          font-size: 16px;
          line-height: 26px;
          padding: 40px 20px;
          box-sizing: border-box;
        }

        .section1-content {
          .content-item {
            width: calc(100% - 40px);
            display: block;

            .item-main {
              width: 100%;

              &:nth-child(2), &:nth-child(4) {
                margin-right: 0;
              }

              .item-title {
                font-size: 32px;
              }

              .item-desc {
                font-size: 16px;
              }

              .item-contact {
                .contact-img {
                  width: 30px;
                  height: 30px;
                }

                .contact-text {
                  line-height: 30px;
                }
              }
            }
          }
        }
      }

      .section2-main {
        .section2-title {
          font-size: 32px;
          line-height: 42px;
          padding-bottom: 80px;
          padding-left: 20px;
        }

        .section2-content {
          .list-main {
            .main-item {
              display: block;

              .item-title {
                width: 100%;
                font-size: 24px;
              }

              .item-content {
                .content-item {
                  width: calc(100% - 40px);

                  .item-subtitle {
                    font-size: 26px;
                  }

                  .item-subcontent {
                    font-size: 16px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media all and (min-width: 320px) and (max-width: 768px) {
  .template-container {
    .template-content {
      .section3-main {
        .section3-title {
          font-size: 32px;
          line-height: 42px;
          padding-bottom: 20px;
          padding-left: 20px;
          padding-right: 20px;
        }

        .section3-content {
          .content-middle {
            padding-top: 50px;
            display: block;

            .middle-left {
              width: calc(100% - 40px);
              margin: 0 auto;
            }

            .middle-right {
              padding: 20px;

              .right-title {
                font-size: 24px;
              }

              .right-desc {
                font-size: 16px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about/contact.vue